module.exports = __webpack_public_path__ + "img/load_sol.18718eaa.png";